import { render, staticRenderFns } from "./Walkthru.vue?vue&type=template&id=6460faf2&scoped=true&"
import script from "./Walkthru.vue?vue&type=script&lang=js&"
export * from "./Walkthru.vue?vue&type=script&lang=js&"
import style0 from "./Walkthru.vue?vue&type=style&index=0&id=6460faf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6460faf2",
  null
  
)

export default component.exports